import React from 'react';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './GenericErrorPanel.module.scss';

const GenericErrorPanel = ({ tag, children, variant, withOverlay, onClose }) => (
  <div data-bem="GenericErrorPanel" data-tag={fromAnyToTrimmed(tag)}>
    {withOverlay && <div className={CN.overlay}></div>}
    <div
      className={cn({
        [CN.component]: true,
        [CN[`${variant}Variant`]]: variant,
      })}
    >
      <div className={CN.container}>
        <div>
          <Icon variant="error" width="xl" />
        </div>

        <div className={CN.content}>
          <div className={CN.staticMessage}>
            Sorry, your last action has failed. If this keeps happening, please contact customer support and provide the
            details below:
          </div>
          <div className={CN.dynamicMessage}>{children}</div>
        </div>
      </div>
      <div>
        <Button variant="empty" onClick={onClose}>
          <Icon variant="close" variantInvert />
        </Button>
      </div>
    </div>
  </div>
);

export default GenericErrorPanel;
